import React from "react";
import EditableCell from "./editable-cell";
import DefaultChip from "./default-chip";
import GetIcon from "@/components/font-awesome-icon";
import { faGripVertical } from "@fortawesome/free-solid-svg-icons";
import * as styles from "./data-column.module.scss";
import { UISimpleTableCell } from "@/components/simple-table";

const DataColumn = ({
  field,
  value,
  id,
  postFix = "",
  index,
  onSave,
  showDefaultChip,
  isDrag = false,
  dragHandleProps = {},
  isDragging,
  canEdit = false,
  customChild = undefined,
}) => {
  const [inputValue, setInputValue] = React.useState("");
  const [isEdit, setEdit] = React.useState(false);
  const onChange = (e) => {
    let value = e.target.value;
    setInputValue(value);
  };

  const doubleClickHandler = (event) => {
    if (event.detail == 2) {
      console.log("Double Clicked");
      setInputValue(value);
      setEdit(true);
    }
  };

  const onCancel = () => {
    setInputValue("");
    setEdit(false);
  };

  const onKeyDown = function (e) {
    if (e.key === "Enter" || e.keyCode === 13 || e.type === "blur") {
      // Do something
      console.log("enter pressed");
      onSave(inputValue, id, index, field);
      onCancel();
    }
  };
  return (
    <UISimpleTableCell
      component="th"
      scope="row"
      className={styles.dataColumnContainer}
      sx={{ py: isEdit ? "8px" : "inherit", px: "5px" }}
      onClick={(e) => (canEdit ? doubleClickHandler(e) : null)}
    >
      {!isEdit ? (
        <span className="InovuaReactDataGrid">
          <span
            className="header-drag-container align-items-center"
            style={{ display: "flex" }}
          >
            {isDrag ? (
              <GetIcon
                iconClass={`header-drag-icon ${styles.grabIcon} ${
                  !isDragging && styles.grabIconVisible
                }`}
                icon={faGripVertical}
                iconStyles={{ marginBottom: "0px" }}
                {...dragHandleProps}
              />
            ) : null}
            <span className={isDrag ? "header-drag-text" : ""}>
              {customChild || value + postFix}
              {showDefaultChip && !isEdit && <DefaultChip />}
            </span>
          </span>
        </span>
      ) : (
        <EditableCell
          field={field}
          value={inputValue}
          onCancel={onCancel}
          onChange={onChange}
          onKeyDown={onKeyDown}
          postFix={postFix}
        />
      )}
    </UISimpleTableCell>
  );
};

export default DataColumn;
